<base-modal class="base-modal experiences-modal" [title]="title" [isProfileMode]="isProfileMode">
  <experience-form
    [formConfigKey$]="formConfigKey$"
    (save)="onSave($event)"
    (cancel)="onCancel()"
    [modalFocus]="modalFocus"
    [editObject]="editFuturePlan"
  ></experience-form>
</base-modal>